import {
    Box, HStack, Input, Button, Table, Thead, Tbody, Tr, Th, Td, Text, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Flex, Image, Heading,
    Alert,
    AlertIcon,
    AlertTitle,
    List,
    ListItem,
    ListIcon,
    OrderedList,
    UnorderedList,
    Textarea,
    Stack,
    VStack,
    Select,
    Link,
    Progress,
    useToast, Accordion, AccordionItem, AccordionButton, AccordionIcon, AccordionPanel,
} from '@chakra-ui/react';
import { FaCopy } from 'react-icons/fa';
import { getAnunciosConcorrencia } from "../services/api";
import { useState, useEffect } from "react";
import Preloader from "../components/Preloader";
import PreloaderMini from "../components/PreloaderMini";
import { formatDistanceToNow, parse, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FiPlus, FiMinus } from 'react-icons/fi';
import { FaSearch } from 'react-icons/fa';
import ScrollToTop from "../components/ScrollToTop";

const Concorrencia = () => {
    const [loading, setLoading] = useState(false);
    const [loadingMini, setLoadingMini] = useState(false);
    const [loadingLinear, setLoadingLinear] = useState(false);
    const [anuncios, setAnuncios] = useState([]);
    const [buscaBool, setBuscaBool] = useState(false);
    const [pagina, setPagina] = useState(1);
    const [ultimaPagina, setUltimaPagina] = useState(1);
    const [totalRegistros, setTotalRegistros] = useState(0);
    const [paginateFrom, setPaginateFrom] = useState(0);
    const [paginateTo, setPaginateTo] = useState(0);
    var consultaLogs = false;
    const toast = useToast()
    const hoje = new Date().toISOString().split('T')[0];

    var dataAtual = new Date();
    var ano = dataAtual.getFullYear();
    var mes = String(dataAtual.getMonth() + 1).padStart(2, '0');
    var dia = String(dataAtual.getDate()).padStart(2, '0');
    var dataFormatadaInicial = `${ano}-${mes}-${dia}`;

    const [filtroId, setFiltroId] = useState("");

    useEffect(() => {
        if (consultaLogs == false) {
            consultarAnuncios(1);
            consultaLogs = true;
        }
    }, []);

    const handleAnterior = () => {
        let paginaAux = pagina - 1;
        if (paginaAux > 1) {
            setPagina(paginaAux);
        } else {
            setPagina(1);
        }
        consultarAnuncios(paginaAux);
    }

    const handleProxima = () => {
        let paginaAux = pagina + 1;
        setPagina(paginaAux);
        consultarAnuncios(paginaAux);
    }

    const handlePrimeira = () => {
        setPagina(1);
        consultarAnuncios(1);
    }

    const handleUltima = () => {
        setPagina(ultimaPagina);
        consultarAnuncios(ultimaPagina);
    }

    const handleChangeFiltroId = (event) => {
        setFiltroId(event.target.value);
    };

    const limparFiltros = () => {
        setFiltroId("");
    };

    const handlePesquisar = () => {
        setPagina(1);
        consultarAnuncios(true);
    };

    function consultarAnuncios(paginaAux) {
        setLoadingLinear(true);
        setLoading(true);
        try {
            (async () => {
                var consulta = "busca=" + filtroId;
                const response = await getAnunciosConcorrencia(consulta);
                if (response != false) {
                    setAnuncios(response.data);
                    // setUltimaPagina(responseLogs.last_page)
                    // setTotalRegistros(responseLogs.total);
                    // setPaginateFrom(responseLogs.from);
                    // setPaginateTo(responseLogs.to);
                    setBuscaBool(false);
                } else {
                    setAnuncios([]);
                    setBuscaBool(true);
                }
                setLoadingLinear(false);
                setLoading(false);
            })();
        }
        catch {
            setLoadingLinear(false);
            setLoading(false);
            return false;
        }
    }

    function limitarCaracteres(str) {
        const limite = 60;
        if (str.length > limite) {
            return str.slice(0, limite) + "...";
        }
        return str;
    }

    const getImgUser = (usuario_id) => {
        var img = "taga_logo.jpg";
        if (usuario_id == 3) {
            img = "/gabriel_logo.webp";
        } else if (usuario_id == 5) {
            img = "/tilio_logo.webp";
        } else if (usuario_id == 6) {
            img = "/riccioppo_logo.webp";
        } else if (usuario_id == 7) {
            img = "/user.png";
        } else if (usuario_id == 8) {
            img = "/gabriel_valiente_logo.webp";
        } else if (usuario_id == 9) {
            img = "/emerson_vendedor_logo.webp";
        } else if (usuario_id == 10) {
            img = "/analuiza_logo.webp";
        }

        return img;
    };

    return (
        <>
            <ScrollToTop />
            {loading && <Preloader />}
            <Box textAlign="center" fontSize="xl" py={10} bg="white" minH="100vh">
                <Box textAlign="center" ml={4} mb={0} fontSize="xl">
                    <Text color={"#F68633"} fontWeight={"bold"}>
                        ANÁLISE DE ANÚNCIOS CONCORRÊNCIA
                    </Text>
                </Box>
                <Box mx={{ base: 1, md: 12, lg: 20 }} mt={0} boxShadow='md' borderRadius="lg" px={0} mb={"10"}>
                    <Box mb={16}>
                        <Text fontSize={"16px"} textAlign="start" ml={4} mt={12} color={"#F68633"} fontWeight={"bold"}>
                            FILTROS
                        </Text>
                        <Flex align={"start"} justifyContent={"start"} flexDirection={{ base: "column", md: "row", lg: "row" }}>
                            <Box mx={4} >
                                <Text textAlign="start" ml={4} mt={2} color={"#F68633"} fontSize={"10px"} fontWeight={"bold"}>
                                    Busca
                                </Text>
                                <Input
                                    boxShadow='lg'
                                    bg={'white'}
                                    color={"black"}
                                    placeholder=""
                                    w={{ base: "250px", md: "300px", lg: "300px", xl: "300px" }}
                                    _placeholder={{
                                        color: 'black',
                                        opacity: 0.6,
                                    }}
                                    _focus={{
                                        border: 'none',
                                    }}
                                    value={filtroId}
                                    onChange={handleChangeFiltroId}
                                />
                            </Box>
                            <Box ml={{ base: 4, md: 0, lg: 0 }}>
                                <Button
                                    mt={6}
                                    p={{ base: 6, md: 0, lg: 0 }}
                                    bg={"#01695E"}
                                    color={"white"}
                                    _hover={{ bg: "white", color: "black", transition: 'background 0.8s, color 0.8s' }}
                                    onClick={handlePesquisar}
                                    boxShadow='lg'
                                >
                                    <FaSearch fontSize='12px' boxShadow='lg' />
                                </Button>
                                <Button
                                    mt={6}
                                    ml={2}
                                    p={{ base: 6, md: 0, lg: 0 }}
                                    bg={"#FF0000"}
                                    color={"white"}
                                    _hover={{ bg: "white", color: "black", transition: 'background 0.8s, color 0.8s' }}
                                    onClick={limparFiltros}
                                    boxShadow='lg'
                                >
                                    X
                                </Button>
                            </Box>
                        </Flex>
                    </Box>
                    {
                        buscaBool && !loading &&
                        <Alert status='warning'>
                            <AlertIcon />
                            <AlertTitle>Nenhum registro encontrado!</AlertTitle>
                        </Alert>
                    }
                    <Box overflowX="auto" mt={10} mx={{ base: "0", sm: "2", md: "6" }}>
                        <Table>
                            <Thead bg={"#bfbdbd"}>
                                <Tr>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">ANÚNCIO</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">Vendedor</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">ID ML</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">NOME</Th>
                                    <Th px={2} borderColor={"none"} textAlign={"center"} fontSize={{ base: "12px", sm: "12px", md: "14px" }} color="#01695E">PREÇO</Th>
                                </Tr>
                            </Thead>
                            <Tbody color={"black"}>
                                {anuncios && !loading && anuncios.map((anuncio) => (
                                    <Tr key={""}
                                        px={2}
                                        _hover={{
                                            background: "#dbdbdb",
                                            transition: "background 0.4s ease-in"
                                        }}
                                        borderColor="green"
                                    >
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "16px" }} textAlign={"center"}>{
                                            <Link href={anuncio.permalink} isExternal>
                                                <Image
                                                    boxShadow='lg'
                                                    src={anuncio.thumbnail}
                                                    alt={"imagem_user"}
                                                    maxW={{ base: "80px", md: "80px", lg: "80px" }}
                                                    maxH="80px"
                                                />
                                            </Link>
                                        }</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "14px" }} textAlign={"center"}>{anuncio.seller.nickname}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "12px", sm: "12px", md: "14px", lg: "14px", xl: "14px" }} textAlign={"center"}>{anuncio.id}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "14px", sm: "14px", md: "14px", lg: "16px", xl: "14px" }} textAlign={"center"} fontWeight={"bold"}>{limitarCaracteres(anuncio.title)}</Td>
                                        <Td px={1} borderColor={"white"} fontSize={{ base: "10px", sm: "10px", md: "12px", lg: "12px", xl: "14px" }} textAlign={"center"}>R${anuncio.price}</Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                    {/* <Flex justifyContent={"center"} mt={6}>
                        <Flex flexDirection={"column"}>
                            <Text fontSize={'10px'} fontWeight={"bold"}>
                                Mostrando {logs ? logs.length : 0} de {totalRegistros} registros do {paginateFrom} ao {paginateTo}
                            </Text>
                            <Flex flexDirection={"row"}>
                                {
                                    pagina != 1 ? (
                                        <Button
                                            onClick={() => handlePrimeira()}
                                        >
                                            {"<<"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled>
                                                {"<<"}
                                            </Button>
                                        )
                                }
                                {
                                    pagina > 1 ? (
                                        <Button
                                            onClick={() => handleAnterior()}
                                        >
                                            {"<"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled
                                            >
                                                {"<"}
                                            </Button>
                                        )
                                }
                                <Button disabled>{pagina}</Button>
                                {

                                    pagina < ultimaPagina ? (
                                        <Button
                                            onClick={() => handleProxima()}
                                        >
                                            {">"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled
                                            >
                                                {">"}
                                            </Button>
                                        )
                                }
                                {
                                    pagina != ultimaPagina ? (
                                        <Button
                                            onClick={() => handleUltima()}
                                        >
                                            {">>"}
                                        </Button>
                                    ) :
                                        (
                                            <Button
                                                bg="gray.300"
                                                disabled
                                            >
                                                {">>"}
                                            </Button>
                                        )
                                }

                            </Flex>
                        </Flex>
                    </Flex> */}
                    {loadingLinear && <Progress mb={0} size='xs' isIndeterminate colorScheme="orange" />}
                </Box>
            </Box>
        </>
    );
};

export default Concorrencia;
